import type { BlockSectionBg } from "./common/types";

export type FormTheme = {
  promoHeadline: string;
  promoBody: string;
  formLabel: string;
  formInput: string;
  formPlaceholder: string;
  formInputBorder: string;
  formFileButton: string;
  formHint: string;
  formDropzoneBorder: string;
  consentText: string;
  consentLink: string;
  checkbox: string;
  successText: string;
};

const lightFormTheme: FormTheme = {
  promoHeadline: "text-primary-foreground",
  promoBody: "text-primary-foreground",
  formLabel: "text-muted-foreground",
  formInput: "text-foreground",
  formPlaceholder: "placeholder:text-muted-foreground data-[placeholder]:text-muted-foreground",
  formInputBorder: "border-border focus:border-foreground",
  formFileButton: "text-foreground hover:text-primary",
  formHint: "text-muted-foreground",
  formDropzoneBorder: "border-border",
  consentText: "text-muted-foreground",
  consentLink: "text-primary",
  checkbox:
    "border-foreground bg-transparent data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
  successText: "text-foreground",
};

/** Figma block_form 2462:4845 — promo stays primary; form surface and text follow section background. */
const formThemeMap: Record<BlockSectionBg, FormTheme> = {
  light: lightFormTheme,
  default: lightFormTheme,
  muted: lightFormTheme,
  dark: {
    promoHeadline: "text-primary-foreground",
    promoBody: "text-primary-foreground",
    formLabel: "text-header-top-fg",
    formInput: "text-secondary-foreground",
    formPlaceholder:
      "placeholder:text-header-top-fg/70 data-[placeholder]:text-header-top-fg/70",
    formInputBorder: "border-header-top-fg/50 focus:border-secondary-foreground",
    formFileButton: "text-secondary-foreground hover:text-primary",
    formHint: "text-header-top-fg/80",
    formDropzoneBorder: "border-header-top-fg/50",
    consentText: "text-header-top-fg",
    consentLink: "text-header-top-fg hover:text-primary",
    checkbox:
      "border-secondary-foreground bg-transparent data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
    successText: "text-secondary-foreground",
  },
  red: {
    promoHeadline: "text-primary-foreground",
    promoBody: "text-primary-foreground",
    formLabel: "text-header-top-fg",
    formInput: "text-primary-foreground",
    formPlaceholder:
      "placeholder:text-header-top-fg/70 data-[placeholder]:text-header-top-fg/70",
    formInputBorder: "border-header-top-fg/50 focus:border-primary-foreground",
    formFileButton: "text-primary-foreground hover:text-primary-foreground/80",
    formHint: "text-header-top-fg/80",
    formDropzoneBorder: "border-header-top-fg/50",
    consentText: "text-header-top-fg",
    consentLink: "text-header-top-fg hover:text-primary-foreground",
    checkbox:
      "border-primary-foreground bg-transparent data-[state=checked]:border-primary-foreground data-[state=checked]:bg-primary-foreground data-[state=checked]:text-primary",
    successText: "text-primary-foreground",
  },
};

export function resolveFormTheme(sectionBg: BlockSectionBg): FormTheme {
  return formThemeMap[sectionBg] ?? formThemeMap.light;
}
